/**
 * The whole list's order after one kind's rows were rearranged. Rows of the
 * other kinds keep their places and the rearranged kind refills its own, so
 * the server still receives every id at once.
 */
export function reorderWithinKind<K, T extends { id: string; kind: K }>(
  records: T[],
  kind: K,
  ids: string[],
): string[] {
  const rearranged = [...ids];
  return records.map((record) =>
    record.kind === kind ? (rearranged.shift() ?? record.id) : record.id,
  );
}
